const BaseClass = require('./base-class');

var EventEmitter = BaseClass.extend({

	initialize(){
		this.listeners = {};
	},

	addEventListener(eventName,callback){
		/* Cria a array com nome eventName caso não exista */
		if (this.listeners[eventName] == undefined) this.listeners[eventName] = [];

		/* inclui o callback, caso não esteja na lista */
		if (this.listeners[eventName].indexOf(callback) == -1) this.listeners[eventName].push(callback);
	},

	removeEventListener(eventName,callback){
		if (this.listeners[eventName] == undefined) return;
		this.listeners[eventName] = this.listeners[eventName].filter(function(c1){
			return c1 != callback;
		});
	},

	emit(eventName,payload){
		var listeners = this.listeners[eventName];
		if (listeners == undefined) return;
		listeners.map(function(callback){
			callback(payload);
		});
	}

});

module.exports = EventEmitter;


/** WEBPACK FOOTER **
 ** ./src/utils/event-emitter.js
 **/